//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { submitAudit, uploadmedia, undocodeaudit } from '@/api/miniProgramManagement.js';
import { CosMixin } from '@/mixins/cos';
export default {
  name: 'SubmitAudit',
  mixins: [CosMixin],
  data() {
    return {
      form: {
        imgs: [],
        videos: [],
      },
      queryAppid: '',
      loading: {
        imgs: false,
        videos: false,
      },
      submitLoading: false,
    };
  },
  computed: {
    imgs() {
      return this.form.imgs
        .map((i) => i.mediaid)
        .filter(Boolean)
        .join(',');
    },
    videos() {
      return this.form.videos
        .map((i) => i.mediaid)
        .filter(Boolean)
        .join(',');
    },
  },
  created() {
    this.queryAppid = this.$route.query.appid;
  },
  methods: {
    // 提交审核
    handleSubmit() {
      this.submitLoading = true;
      const { version_desc: versionDesc, imgs, videos } = this.form;
      console.log(imgs, videos);
      const imgsList = imgs.map((i) => i.mediaid).filter(Boolean);
      const videosList = videos.map((i) => i.mediaid).filter(Boolean);
      const data = {
        version_desc: versionDesc,
        preview_info: {
          video_id_list: videosList,
          pic_id_list: imgsList,
        },
      };
      console.log('data', data);
      submitAudit({ app_id: this.queryAppid, body: JSON.stringify(data) })
        .then((res) => {
          console.log(res);
          this.$message.success('提交成功');
          this.submitLoading = false;
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
          this.submitLoading = false;
        });
    },
    async upload(e, type) {
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      const s = e.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      // 截取文件类型
      const lastPointIndex = rs.lastIndexOf('.');
      const suffix = rs.substring(lastPointIndex);
      const cosParams = {
        imgCosKey: `${e.file.uid}${rs}`,
        fileObject: e.file,
        suffix,
      };
      try {
        this.loading[type] = true;
        console.log('e', e.file);
        const res = await this.putCosObject(cosParams);
        if (res?.data) {
          const { mediaid } =
            (await uploadmedia({
              appid: this.queryAppid,
              file_url: res.data,
              file_name: e.file.name,
            })) || {};
          console.log('mediaid', mediaid);
          if (mediaid) {
            this.form[type].push({
              uid: e?.file?.uid,
              mediaid,
            });
          }
          this.loading[type] = false;
        }
      } catch (err) {
        console.error(err);
        this.loading[type] = false;
        this.$message.error('上传失败,请稍后重试', err);
      }
    },
    undocodeaudit() {
      undocodeaudit({ app_id: this.queryAppid });
    },
    cancel() {
      this.$router.go(-1);
    },
    remove(file, type) {
      this.form[type] = this.form[type].filter((i) => i.uid !== file.uid);
    },
  },
};
